import type {
  PrognosisAssetClass,
  PrognosisAssetFraction,
} from '@festina/unitlink-general-types/unitlink'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikPercentageInput,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useEnumOptions } from '../../../hooks/useEnumOptions'

type Props = {
  fieldNamePrefix: ValidatedKey
}

export const PrognosisAssetFractionFields = ({ fieldNamePrefix }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const prognosisAssetClassOptions = useEnumOptions(
    'PrognosisAssetClass',
    'unitlink',
  )

  const validateKey =
    typeUtils.createNestedValidator<PrognosisAssetFraction>(fieldNamePrefix)

  return (
    <>
      <FormikSelect
        name={validateKey('prognosisAssetClass')}
        label={translate('funds.prognosisAssetFraction.prognosisAssetClass')}
        options={prognosisAssetClassOptions}
        renderFn={(x: PrognosisAssetClass) =>
          translateEnum('unitLink.enum.PrognosisAssetClass', x)
        }
      />
      <FormikPercentageInput
        name={validateKey('fraction')}
        label={translate('funds.prognosisAssetFraction.fraction')}
      />
    </>
  )
}
